import * as React from 'react';

const Pencil = (): JSX.Element => {
  return (
    <svg
      width="19"
      height="19"
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.709 5.04006C18.099 4.65006 18.099 4.00006 17.709 3.63006L15.369 1.29006C14.999 0.900059 14.349 0.900059 13.959 1.29006L12.119 3.12006L15.869 6.87006L17.709 5.04006ZM-0.000976562 15.2501V19.0001H3.74902L14.809 7.93006L11.059 4.18006L-0.000976562 15.2501Z"
        fill="white"
      />
    </svg>
  );
};

export { Pencil };



// WEBPACK FOOTER //
// ./src/components/svg/Pencil.tsx